import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {ssrSafeLocation} from '@github-ui/ssr-utils'
import {FlexTemplate} from '@github-ui/swp-core/layouts/contentful/FlexTemplate'
import {LandingPageWebVitalsTracker} from '../components/LandingPageWebVitalsTracker/LandingPageWebVitalsTracker'
import resolveResponse from 'contentful-resolve-response'
import {FreeFormTemplate, Universe23WaitlistTemplate, ContactSalesTemplate, OverviewTemplate} from '../layouts'
import {F2Template} from '../layouts/F2Template'
import {toContainerPage, toEntryCollection, type ContainerPage} from '../lib/types/contentful'
import {toPayload} from '../lib/types/payload'

function getReactComponentFor<Page extends ContainerPage>(page: Page): React.ElementType {
  const map: Record<ContainerPage['fields']['template']['sys']['contentType']['sys']['id'], React.ElementType> = {
    templateF2: F2Template,
    templateFlex: FlexTemplate,
    templateFreeForm: FreeFormTemplate,
    templateUniverse23Waitlist: Universe23WaitlistTemplate,
    templateContactSalesForm: ContactSalesTemplate,
    templateFlexSuiteOverview: OverviewTemplate,
  }

  return map[page.fields.template.sys.contentType.sys.id]
}

export const ShowPage = () => {
  const {contentfulRawJsonResponse, userLoggedIn, octocaptchaHost, hasNtExperiences} =
    toPayload(useRoutePayload<unknown>())
  const page = toContainerPage(toEntryCollection(resolveResponse(contentfulRawJsonResponse)).at(0))

  const PageComponent = getReactComponentFor(page)

  // Only track /features/:slug pages for Web Vitals
  const pathSegments = ssrSafeLocation.pathname.split('/').filter(Boolean)
  const pageIdentifier = pathSegments[0] === 'features' && pathSegments[1] ? `features.${pathSegments[1]}` : null
  const isWebVitalsTrackingEnabled = isFeatureEnabled('landing_pages_web_vitals_tracking')

  return (
    <>
      {isWebVitalsTrackingEnabled && pageIdentifier && <LandingPageWebVitalsTracker page={pageIdentifier} />}
      {/* eslint-disable-next-line react-hooks/static-components */}
      <PageComponent
        page={page}
        userLoggedIn={userLoggedIn}
        octocaptchaHost={octocaptchaHost}
        hasNtExperiences={hasNtExperiences}
      />
    </>
  )
}
